import { useState, useEffect, useMemo } from 'react';
import useI18n from 'i18n/useI18n';

const useTranslatedSelect = ( baseOptions = null, iniOption = null ) => {
  const [selectedOption, setSelectedOption] = useState(null);
  const { translate, selectedLang } = useI18n();

  const options = useMemo(()=>{
    if(!baseOptions ) return null;
    return baseOptions.map( option => ({
      ...option,
      label: translate(option.label)
    }));
  }, [selectedLang]);

  useEffect(()=>{
    let selected = null;    
    if( !selectedOption ){
      selected = !!iniOption ? iniOption : baseOptions[0];
    } else {
      selected = baseOptions.find(
        option => option.value === selectedOption.value
      );
    }

    setSelectedOption({
      ...selected,
      label: translate(selected.label)
    });   
  }, [selectedLang]);

  return ([
    options,
    selectedOption,
    setSelectedOption,
  ]);
}
export default useTranslatedSelect;